export class GameStateModel {
  gamePath: string;
  gameRedirect: string;
}
